import axios from 'axios';
import { API_BASE_URL } from './environment';

// Axios instance oluştur
// Environment konfigürasyonundan API URL'ini al
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - her istekte token ve dil bilgisi ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Dil bilgisini header olarak ekle
    const language = localStorage.getItem('language') || 'tr';
    config.headers['Accept-Language'] = language;
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - hata yönetimi
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Token geçersizse ve login sayfasında değilsek login sayfasına yönlendir
    if (error.response && error.response.status === 401) {
      // Mevcut URL'i kontrol et
      const currentPath = window.location.pathname;
      const isLoginPage = currentPath === '/login' || currentPath === '/admin' || currentPath === '/superadmin';
      
      // Eğer login sayfasında değilsek, token'ı temizle ve yönlendir
      if (!isLoginPage) {
        // Önce kullanıcı tipini al
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const isCustomer = user.user_type === 'customer';
        
        // Sonra localStorage'ı temizle
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Kullanıcı tipine göre doğru login sayfasına yönlendir
        if (isCustomer) {
          window.location.href = '/login';
        } else {
          window.location.href = '/admin';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
